import React from "react"
import { formattedNumber, isEvenItem } from "../../../utils"
const CommonOverView = ({ data }) => {
  const getImage = () => {
    if (data.mobileImages) {
      return data.mobileImages.map((image, index) => (
        <div key={"mobile-image" + (index + 1)}>
          <img
            src={image.url}
            alt={image.label}
            className={`${isEvenItem(index) ? "w-[110px]" : "w-[100px]"}  md:w-full`}
            loading="lazy"
          />
        </div>
      ))
    }
    return (
      <div>
        <img
          src={data.webImage.url}
          alt={data.webImage.label}
          className="w-[370px] md:w-full   "
          loading="lazy"
        />
      </div>
    )
  }
  return (
    <div className="md:px-20 h-full md:pe-10 xl:pe-20 px-6 flex md:flex-col  gap-32 md:gap-0 pt-12 md:pt-[2.75rem]  w-max xl:w-full">
      <div className="items-start md:items-center flex flex-shrink-0 gap-8  flex-row ">
        <div className="flex  flex-col gap-4 md:gap-10 w-[390px] md:w-[480px] xl:w-[597px] flex-shrink-0">
          <div className="flex flex-col gap-3 md:gap-4 w-full">
            <div className="flex items-center gap-2">
              <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
              <h4
                className={`text-gray-500 text-lg lg:text-2xl tracking-[-0.56px] md:tracking-tight-4%`}
              >
                About
              </h4>
            </div>
            <h1
              className={`text-blue-100 text-6xl md:text-5xl lg:text-8xl tracking-[-3.36px] lg:tracking-tight-7%`}
            >
              {data.title}
            </h1>
            {data.matrixData && (
              <div className="flex md:hidden flex-grow gap-x-16 md:gap-x-12 xl:gap-x-20 md:24 xl:ms-32 px-0  flex-shrink-0">
                {data.matrixData.map(matrix => (
                  <div
                    key={matrix.title}
                    className="flex self-stretch flex-col  justify-start gap-3 md:gap-6 py-3 md:py-10"
                  >
                    {typeof matrix.stat === "number" ? (
                      <h3 className="flex font-oxygen items-center text-blue-100 md:leading-[0.6] leading-[1]  relative md:-tracking-[0.375rem] tracking-[-1.28px] text-[2.5rem] md:text-[3.75rem]">
                        {formattedNumber(matrix.stat)}
                        <div className=" ms-2 text-[2.5rem]">+</div>
                      </h3>
                    ) : (
                      <h3 className="flex  items-center text-blue-100 md:leading-[0.6] leading-[1]  relative md:-tracking-[0.375rem] tracking-[-2.28px] text-[2.5rem] md:text-[3.75rem]">
                        {matrix.stat}
                      </h3>
                    )}

                    <p className="-tracking-[0.32px]  text-black-100 text-base ">
                      {matrix.title}
                    </p>
                  </div>
                ))}
              </div>
            )}

            <p className={`text-[1.125rem] text-gray-900 `}>
              {data.description}
            </p>
            {!!data.tags.length && (
              <div className=" w-full md:w-auto pb-3 md:pb-0 flex  flex-wrap gap-2 md:mt-4 mt-2 items-center">
                {data.tags.map((item, index) => (
                  <div
                    key={index}
                    className={`px-3 text-gray-500 border-gray-500 py-1 text-nowrap tracking-tight border rounded-full text-[0.875rem] `}
                  >
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {data.matrixData && (
          <div className="hidden md:flex flex-grow md:gap-x-12 xl:gap-x-20 md:24 xl:ms-32 px-0  flex-shrink-0">
            {data.matrixData.map(matrix => (
              <div
                key={matrix.title}
                className="flex self-stretch flex-col  justify-start gap-4 md:gap-6 py-5 md:py-10"
              >
                {typeof matrix.stat === "number" ? (
                  <h3 className="flex font-oxygen items-center text-blue-100 md:leading-[0.6] leading-[1]  relative md:-tracking-[0.375rem] tracking-tight text-[3.75rem] md:text-[3.75rem]">
                    {formattedNumber(matrix.stat)}
                    <div className=" ms-2 text-[3.75rem]">+</div>
                  </h3>
                ) : (
                  <h3 className="flex  items-center text-blue-100 md:leading-[0.6] leading-[1]  relative md:-tracking-[0.375rem] tracking-tight text-[3.75rem] md:text-[3.75rem]">
                    {matrix.stat}
                  </h3>
                )}

                <p className="-tracking-[0.32px]  text-black-100 text-base ">
                  {matrix.title}
                </p>
              </div>
            ))}
          </div>
        )}
        {data.matrixIcons && (
          <div className="flex flex-grow gap-x-16 md:gap-x-12 xl:gap-x-20 md:24 xl:ms-32 px-0  flex-shrink-0">
            {data.matrixIcons.map(matrix => (
              <div
                key={matrix.label}
                className="flex self-stretch flex-col  items-center justify-center gap-3 md:gap-6 py-3 md:py-10"
              >
                <div className="bg-primary-100 p-6 w-32 h-32 rounded-[50%] flex items-center justify-center">
                  <img src={matrix.icon} alt={matrix.label} loading="lazy" />
                </div>

                <p className="-tracking-[0.32px]  text-black-100 text-base ">
                  {matrix.label}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="flex basis-full  md:w-9/12 xl:w-full mx-auto justify-center  gap-12 md:mt-0 xl:mt-16 items-center xl:items-end">
        {getImage()}
      </div>
    </div>
  )
}

export default CommonOverView
